/* eslint-disable @typescript-eslint/no-explicit-any */
import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import baseAxios from "axios"
import type { MaterialItem, NewCustomSpu, SingleCoupon, NewExternalCustomSpu } from "../types"


// 根本商品id查询详情
export const getCustomSpu = async (categoryId: string, spuId: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/categories/${categoryId}/spus/${spuId}`)
}

// 获取用户的优惠卷
export const getCoupon = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/activity`, {})
}

export const fetchFontList = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/pms/custom_fonts`, {})
}

// 领券中心  待领取
export const getCouponList = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get("/v1/api/activity?type=notJoin", {})
}

// 我的优惠券
// 1 CLAIMED type=1 - 已领取 待使用
// 2 USED type=2 - 已使用
// 3 EXPIRED type=3 - 已失效
export const getMyCouponList = async (type: number) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/activity/coupons?type=${type}`, {})
}

// 领取优惠券
export const receiveCoupon = async (id: number) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post(`/v1/api/activity/${id}/coupons/claim`, {})
}

// 创建图像
export const createMJImg = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/mj/create`, data)
}
// 查询主图
export const fetchMainImg = async (taskId: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/mj/queryGroup/${taskId}`)
}

// 查询主图下的4张子图
export const fetchFourMJImg = async (groupId: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/mj/querySub/${groupId}`)
}

// 查询历史
export const fetchFourMJImgHistroy = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/mj/queryHistory`)
}

export const fetchWXConfig = async (url: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/fb/config_by_wxapp`, url)
}

export const fetchAllCustomSpus = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pms/custom/spus", data)
}

export const fetchAllSpus = async (condition?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pms/spus", condition)
}

// 创建商品
export const submitCustomSpu = async (data: NewCustomSpu): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/pms/custom/spus", data)
}
// 创建商品
export const submitExternalCustomSpu = async (data: NewExternalCustomSpu): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/pms/external/custom/spus", data)
}

export const updateCustomSpu = async (data: NewCustomSpu, id: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/pms/custom/spus/${id}`, data)
}
// 商品详情
export const fetchCustomSpu = async (key: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/custom/spus/${key}`)
}

export const fetchProductSku = async (id: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/spu/${id}/skus`)
}

// 商品详情图片
export const fetchSpuImages = async (key: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/spus/${key}/images`)
}

// 添加用户图片历史
export const addMateriaImage = async (data: any): Promise<any> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/pms/materials/user`, data)
}

export const updateCustomSpuName = async (key: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/pms/custom/spus/${key}/name`, data)
}

// 删除商品
export const deleteCustomSpu = async (spuId: object): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.axios({
    method: 'delete',
    url: '/v1/api/pms/custom/spus',
    params: spuId,
  })
}

// 加入购物车
export const addShoppingCartItem = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/oms/cart", data)
}

// 购物车查询
export const fetchShoppingCart = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/oms/cart")
}

// 数量修改
export const updateQualityOfShoppingCartItem = async (key: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/cart/${key}`, data)
}

// 删除购物车商品
export const deleteShoppingCartItems = async (ids: number | number[]): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.axios({
    method: 'delete',
    url: '/v1/api/oms/cart',
    params: { ids: Array.isArray(ids) ? ids.join() : ids },
  })
}

// 默认地址
export const fetchDefaultAddress = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/ums/addresses_default")
}

export const fetchOrderOfCustomSpu = async (custom_spu_id: number) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/custom/spus/${custom_spu_id}/order`)
}

export const fetchAddresses = async () => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/ums/addresses")
}

export const uploadHighDefinitionImage = async (blob: Blob) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  const fd = new FormData()
  fd.append("fileBlob", blob, `custom.png`) // 目前后端做的验证必须加后缀
  return axios
    .post("/v1/api/directAttachment/material", fd)
    .then((res: any) => {
      return res.uploaded
    })
}

export const uploadCustomImage = async (blob: Blob) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  const fd = new FormData()
  fd.append("fileBlob", blob, `custom.png`) // 目前后端做的验证必须加后缀
  return axios
    .post("/v1/api/attachment/custom_spus", fd)
    .then((res: any) => {
      return res.uploaded
    })
}

// 新增订单
export const addOrder = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/oms/order", data)
}

// 查询已购成套设计
export const fetchOrder = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/dss/order", data)
}

// 新增图片的使用
export const addUmsDssOrderItem = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/dss/order/customized_image", data)
}

// 新增订单
export const addDssOrder = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/dss/order", data)
}

// 查询微信支付是否存在
export const dssWxpayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/dss/wxpay/query", data)
}

// 查询支付宝支付是否存在
export const dssAlipayQuery = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/dss/alipay/query", data)
}

// 查询主题列表
export const fetchShareThemeList = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/design_share/theme_list`, data)
}

// 查询快递
export const getExpress = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pdm/express/companies")
}

// 查询快递价格
export const getExpressRate = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pdm/express/rate", data)
}

// 查询素材库
export const getMaterialList = async (data?: any): Promise<MaterialItem[]> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pms/materials", data)
}

// 查询素材库
export const getTechnology = async (): Promise<any> => {
  return await baseAxios.get("/admin/v1/api/dictionaries/technologyTag")
}

// 获取产品素材
export const getUserMaterialList = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/pms/materials/user`, data)
}

export const fetchMaterialTag = async (): Promise<any> => {
  return await baseAxios.get('/admin/v1/api/dictionaries/materialTag')
}

// 查询微信是否支付成功
export const wxpayQuery = async (data?: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/oms/wxpay/query", data)
}

// 解析glb文件
export const analysisGlb = async (url: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`${url}`, {}, { withCredentials: false })
}

export const signinByToken = async (token: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post("/v1/api/fb/signin_by_token", { id: token, token })
}
export const getSale = async (id: string): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/user/sale/${id}`)
}

export const getAccount = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get(`/v1/api/oms/user/account`)
}

export const getStripe = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/create-checkout-session`)
}

export const paypalNotify = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/oms/paypal/notify`, data)
}

export const directOrder = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/oms/direct/order`, data)
}

// 提交抠图任务（后端代理阿里云 viapi SegmentHDCommonImage，前端不接触 AccessKey）
export async function viapiSegment(imageUrl: string): Promise<{ requestId?: string; raw?: any }> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post('/v1/api/pms/viapi/segment', { imageUrl })
}

// 查询抠图异步任务结果（后端代理阿里云 viapi GetAsyncJobResult）
export async function viapiJobResult(jobId: string): Promise<{ raw: any }> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post('/v1/api/pms/viapi/jobResult', { jobId })
}